<template>
   <div class="mdmemo-container" v-if="isMounted">
    <BaseInputWithContextMenu
      :target-id="inputElementId"
      :is-read-only="isReadOnlyState"
      :value="value"
      :enable-speech-features="true"
      :enable-system-options="true"
      @input="onInput"
      @control-changed="setChangedStatus"
      :control-id="Name"
    >
      <div v-if="VisibleLabel" class="textlabel" :data-label="Label"></div>
      <b-form-textarea
          class="MdMemo"
          :class="UseDinamicClass ? 'cutescroll '+DynamicClass : 'cutescroll'"
          :id="inputElementId"
          :name="Name"                       
          :rows="Rows"
          :autofocus="isAutoFocus"
          :max-rows="MaxRows"
          :maxlength="MaxLength"
          :disabled=this.isReadOnly
          :placeholder="Placeholder"
          v-bind:value="value"
          v-on:change="OnChange"
          v-on:input="onInput"
          v-bind:style="style"
      ></b-form-textarea>
    </BaseInputWithContextMenu>
  </div>
</template>

<script>
  import { EventBus } from '@/event-bus.js';
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";

  Vue.use(ContextMenuPlugin);
  export default {
    name: 'MdMemo',
   props: {     
     MaxRows: String,
     Rows: String,
     MaxLength: String,
     Label:String,
     isReadOnly:Boolean,
     value:[String, Number],
     Name:String,
     Placeholder:String,
     Tag: String,
     isRequired: Boolean,
     isValid:Boolean,
     UseDinamicClass:Boolean,
     DynamicClass:String,
     VisibleLabel:Boolean,
     OnAuxFunc:Function,
     IsAux:Boolean,
     NoValidateChanges:Boolean,
     IdButton:String,
     isAutoFocus:Boolean,
     Obj1:Object
   },
    watch: {
      isValid: function (newValue) {
        this.setValid(newValue)
      }
    },
    data() {
      return {
        style: {
          border: 'solid 1px #e0e0e0 !important',
          borderColor: '#e0e0e0 !important',
          padding: '5px'
        },
        Invalid: false,
        menuItems:[],
        isMounted: false
      }
    },
    computed: {
      inputElementId() {
        return this.Name;
      },
      
      isReadOnlyState() {
        return  this.isReadOnly;
      }
    },
    methods:{
      OnChange(value){
        this.$emit('input',value)
      },

      onInput(evt){
        const val = evt && evt.target ? evt.target.value : evt;
        this.setChangedStatus(val);
        this.Invalid = val.length == 0 && this.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important' : '#e0e0e0 !important';
        if (this.IsAux && typeof this.OnAuxFunc === 'function') {
          this.OnAuxFunc();
        }
        // sync with external v-model
        this.$emit('input', val);
      },

      setValid(state) {
        this.style.borderColor = state ? '#e0e0e0 !important' : '#dc3545 !important'
      },

      setRequired(value) {
        this.isRequired = value;
        if (!value) {
          this.style.borderColor = '#e0e0e0 !important';
        }
      },

      setChangedStatus( sp ){
        this.$emit('input', sp)
        var changed = {
          "Changed":true,
          "ComponentName":this.Name,
          "Tag": this.Tag,
          "IdButton":this.IdButton,
          "Obj1":this.Obj1,
          "Value" : sp 
        }
        if(!this.NoValidateChanges){
          EventBus.$emit('onChanged', changed);
        } 
      },

      updateValue(newValue) {
        this.$emit('input', newValue);
      },

      getControlId() {
        return this.Name;
      },

      // 🔹 Lógica de Speech-to-Text
      setValueS2T(sp) {
        const sp2t = (this.value || '') + sp;
        this.$emit('input', sp2t);
        this.setChangedStatus(sp2t);
      },
  },
  mounted(){
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  created() {
      EventBus.$on("receivedS2T", function (event) {
        if( event.ControlId == this.Name) { 
            this.setValueS2T( event.finalSentence )
        }
      }.bind(this))
  }
}
</script>
